var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-sticky-spacer",class:{
    'native-sticky': _vm.useNative,
  },style:(_vm.spacerStyles)},[_c('div',{ref:"sticky",staticClass:"layout-sticky",class:{
      'is-fullwidth': _vm.fullwidth,
      'is-sticky': _vm.isSticky && !_vm.useNative,
    },style:(_vm.stickyStyles)},[_vm._t("default",null,{"isSticky":_vm.isSticky})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }